import { render, staticRenderFns } from "./TabellaListaInterventi.vue?vue&type=template&id=6e52f7a6&scoped=true&"
import script from "./TabellaListaInterventi.vue?vue&type=script&lang=js&"
export * from "./TabellaListaInterventi.vue?vue&type=script&lang=js&"
import style0 from "./TabellaListaInterventi.vue?vue&type=style&index=0&id=6e52f7a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e52f7a6",
  null
  
)

export default component.exports